var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_507_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9987 3.99992L5.33203 2.66659M5.33203 2.66659L3.9987 1.33325M5.33203 2.66659H3.9987C2.52594 2.66659 1.33203 3.86049 1.33203 5.33325M11.9987 11.9999L10.6654 13.3333M10.6654 13.3333L11.9987 14.6666M10.6654 13.3333H11.9987C13.4715 13.3333 14.6654 12.1393 14.6654 10.6666M8.94348 8.9447C9.46498 9.19379 10.0489 9.33325 10.6654 9.33325C12.8745 9.33325 14.6654 7.54239 14.6654 5.33325C14.6654 3.12411 12.8745 1.33325 10.6654 1.33325C8.45623 1.33325 6.66536 3.12411 6.66536 5.33325C6.66536 5.94973 6.80482 6.53363 7.05392 7.05514M9.33203 10.6666C9.33203 12.8757 7.54117 14.6666 5.33203 14.6666C3.12289 14.6666 1.33203 12.8757 1.33203 10.6666C1.33203 8.45745 3.12289 6.66658 5.33203 6.66658C7.54117 6.66658 9.33203 8.45745 9.33203 10.6666Z",
    stroke: "#0C0C0D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_507_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapDark);
export default __webpack_public_path__ + "static/media/swap_dark.37b905f6b88c1f32c249d5e6d856dc44.svg";
export { ForwardRef as ReactComponent };